import { ErrorCode, ErrorStatus, ErrorTargets } from '@opositatest/universal/models/response';
import { Mapper } from '../../../mappers/mapper.type';
import { NetworkError, NetworkErrorCodes, ServerError, ServerErrorCodes } from '../types';

const mapNetworkError: Mapper<any, NetworkError.ErrorWrapper> = error => {
  return {
    error: {
      status: 0,
      code: NetworkErrorCodes.ConnectionIssues,
      message: error.message,
      target: ErrorTargets.Network,
    },
  };
};

// @ts-expect-error
const mapServerError: Mapper<any, ServerError.ErrorWrapper> = error => {
  let status: ErrorStatus = error.status,
    code: ErrorCode = ServerErrorCodes.InternalServerError;

  switch (status) {
    case 501:
      code = ServerErrorCodes.NotImplemented;
      break;
    case 502:
      code = ServerErrorCodes.BadGateway;
      break;
    case 503:
      code = ServerErrorCodes.ServiceUnavailable;
      break;
    case 504:
      code = ServerErrorCodes.GatewayTimeout;
      break;
  }

  return {
    error: {
      status,
      code,
      message: error.message,
      target: ErrorTargets.Server,
    },
  };
};

export { mapNetworkError, mapServerError };
